import React, { createContext, useContext, useCallback, useLayoutEffect, useRef } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const themeRef = useRef('dark');

  const applyTheme = useCallback((newTheme) => {
    themeRef.current = newTheme;
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(newTheme);
  }, []);

  const setThemeForRoute = useCallback((pathname) => {
    if (pathname.startsWith('/bestellen')) {
      applyTheme('light');
    } else {
      applyTheme('dark');
    }
  }, [applyTheme]);

  return (
    <ThemeContext.Provider value={{ themeRef, setThemeForRoute }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export function useRouteTheme(pathname) {
  const { setThemeForRoute } = useTheme();
  
  // Apply immediately during render for SSR/first-paint correctness
  if (typeof document !== 'undefined') {
    if (pathname.startsWith('/bestellen')) {
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.add('light');
      document.body.style.backgroundColor = '#FAFAF8';
      document.body.style.color = '#292524';
    } else {
      document.documentElement.classList.remove('light');
      document.documentElement.classList.add('dark');
      document.body.style.backgroundColor = '';
      document.body.style.color = '';
    }
  }
  
  useLayoutEffect(() => {
    setThemeForRoute(pathname);
  }, [pathname, setThemeForRoute]);
}
